import React, { Suspense } from 'react';

import type { MapPin } from './VenueMapCanvas';
import './VenueMapCanvas.scss';

export type { MapPin };

// Leaflet is only needed on the venues page and the control panel's Map tab, so it loads
// when a map is first shown rather than with the rest of the app.
const VenueMapCanvas = React.lazy(() => import('./VenueMapCanvas'));

type Props = React.ComponentProps<typeof VenueMapCanvas>;

const VenueMap = (props: Props) => (
  <Suspense fallback={<div className={props.className ? `venue-map ${props.className}` : 'venue-map'} />}>
    <VenueMapCanvas {...props} />
  </Suspense>
);

export default VenueMap;
